import { ErroHttp } from '@/shared/utils/erroHttp';
import type { FalhaDaRespostaDoCore } from '@/shared/utils/respostaDoCore';

import type { FalhaDaDefinicaoDeFinalidade } from '../../types/templatesWhatsappGestao';
import { conflitoDeFinalidadeEmDetalhes } from '../../utils/templatesWhatsappGestao';

const CODIGO_FINALIDADE_EM_USO = 'TEMPLATE_FINALIDADE_EM_USO';

/**
 * `ErroHttp` com o `details` do corpo preservado. O `ErroHttp` padrão de
 * `lerDadosDaRespostaDoCore` descarta o `details`, e é nele que o 409 traz os usos que a troca de
 * finalidade quebraria.
 */
export class ErroDaGestaoDeTemplateWhatsapp extends ErroHttp {
  readonly detalhes: unknown;

  constructor({ mensagem, status, codigo, detalhes }: FalhaDaRespostaDoCore) {
    super(mensagem, status, null, codigo);
    this.name = 'ErroDaGestaoDeTemplateWhatsapp';
    this.detalhes = detalhes;
  }
}

/**
 * Um 409 com `details` fora do contrato cai como recusa simples: a mensagem do core ainda diz que
 * o template está em uso, e listar usos pela metade seria pior do que não listar.
 */
export function falhaDaDefinicaoDeFinalidade(
  erro: unknown,
  mensagemPadrao: string,
): FalhaDaDefinicaoDeFinalidade {
  const mensagem = erro instanceof Error && erro.message ? erro.message : mensagemPadrao;
  const conflito =
    erro instanceof ErroDaGestaoDeTemplateWhatsapp && erro.codigo === CODIGO_FINALIDADE_EM_USO
      ? conflitoDeFinalidadeEmDetalhes(erro.detalhes)
      : null;
  return conflito ? { tipo: 'emUso', mensagem, ...conflito } : { tipo: 'recusada', mensagem };
}
